import {
  chipPriceLabel,
  formatDisplayPrice,
  getMembershipPricePair,
  resolveCatalogPriceDisplay,
} from '../utils/servicePriceOptions';

/**
 * Franchise / register service price with optional MRP strike + sale.
 */
export default function ServiceCatalogPrice({ service, chosen, className = '' }) {
  if (!chosen) {
    const pair = getMembershipPricePair(service);
    if (pair) {
      return (
        <span className={`fi-svc-picker__price-membership${className ? ` ${className}` : ''}`}>
          <span className="fi-svc-picker__price-member-line">
            <span className="fi-svc-picker__price-tier">Member</span>
            <span>{pair.member.displayPrice}</span>
          </span>
          <span className="fi-svc-picker__price-member-line">
            <span className="fi-svc-picker__price-tier">Non-member</span>
            <span>{pair.nonMember.displayPrice}</span>
          </span>
        </span>
      );
    }
  }

  const row = chosen || service;
  const display = resolveCatalogPriceDisplay(row, service);
  if (!display) {
    const fallback = chipPriceLabel(row || service);
    if (!fallback) return <span className={className} />;
    return <span className={className}>{fallback}</span>;
  }
  if (display.kind === 'sale') {
    return (
      <span className={`fi-svc-picker__price-pair${className ? ` ${className}` : ''}`}>
        <span className="fi-svc-picker__price-mrp">{formatDisplayPrice(display.mrp)}</span>
        <span className="fi-svc-picker__price-sale">{formatDisplayPrice(display.sale)}</span>
      </span>
    );
  }
  return (
    <span className={className}>
      {formatDisplayPrice(display.mrp) || chipPriceLabel(row || service)}
    </span>
  );
}
